import styled from 'styled-components';

export const Contain = styled.div`
  height: 100%;
  padding-bottom: 130px;
`;

export const Texto = styled.h2`
  font-size: 30pt;
  color: var(--primary-color-sefaz);
  text-align: center;
  margin-bottom: 0;
`;

export const SubTexto = styled.h2`
  font-size: 22pt;
  color: var(--primary-color-sefaz);
  text-align: center;
`;

export const ContainerImagem = styled.div`
  margin-top: 20%;
  text-align: center;
`;
